import { createSignal } from 'solid-js'

export type FlyingCoin = {
  id: number
  kind: 'coin' | 'gem'
  startX: number
  startY: number
  endX: number
  endY: number
}

const [flyingCoins, setFlyingCoins] = createSignal<FlyingCoin[]>([])

let nextFlyingId = 0

export const flying = {
  list: flyingCoins,
  spawn(burst: Array<Omit<FlyingCoin, 'id'>>) {
    setFlyingCoins((prev) => [
      ...prev,
      ...burst.map((c) => ({ ...c, id: ++nextFlyingId })),
    ])
  },
  remove(id: number) {
    setFlyingCoins((prev) => prev.filter((c) => c.id !== id))
  },
}
